import * as React from 'react';
import styled from 'styled-components';
import AuthPageSection from './_AuthPageSection';
import { COLORS, BREAKPOINTS } from '../styles';

export const InformationContainer = styled(AuthPageSection)<{ color: string }>`
  display: none;
  background: ${props => props.color};

  ${BREAKPOINTS.MEDIUM} {
    display: flex;
    padding-top: 56px;
  }
`;

export const InformationContent = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;
  text-align: center;
  max-width: 100%;

  ${BREAKPOINTS.LARGE} {
    align-self: flex-end;
    margin-right: 48px;
  }
`;

export const InformationHeader = styled.h2`
  font-style: normal;
  font-weight: 300;
  font-size: 48px;
  line-height: 140%;
  margin-bottom: 0;
`;

export const InformationText = styled.p`
  font-size: 20px;
  line-height: 140%;
  color: ${COLORS.neutral_600};
  margin: 8px 0;
`;

export const InformationImage = styled.img`
  height: 275px;
  max-width: 100%;
`;
